<div class="flex flex-col lg:flex-row lg:justify-between lg:items-center bg-white p-6 border-t border-[#E7EAF0] gap-4">
    <div class="flex gap-3 flex-1">
        <img class="w-12 h-12 rounded-lg" alt="GroupIcon" [src]="groupManagementSignal().post.group.photo" />
        <div class="flex flex-col gap-[5px] w-full">
            <p class="text-[0.875rem] text-[#717182]">{{ timeAgo(groupManagementSignal().createdAt) }}</p>
            <p class="text-[#0A0A0A] font-medium text-sm">
                {{ groupManagementSignal().post.author.name }} has been reported as "{{
                    groupManagementSignal().reason
                }}"
            </p>
        </div>
    </div>

    <div class="flex gap-2 w-full lg:w-auto">
        <button
            type="button"
            class="border-button text-sm p-2 px-3 gap-2 flex items-center w-full lg:w-auto whitespace-nowrap"
            [routerLink]="['/post', groupManagementSignal().post.id]">
            <p>View Posts</p>
        </button>
        @if (groupManagementSignal().post.group.role !== 'moderator') {
            <button
                type="button"
                class="white-border-button text-sm p-2 px-3 gap-2 flex items-center text-[#D4183D] border border-[#D4183D] w-full lg:w-auto whitespace-nowrap"
                (click)="
                    removeReportedMember(groupManagementSignal().post.group.id, groupManagementSignal().post.author.id)
                ">
                <img class="w-4 h-4" alt="Remove" src="/assets/images/shared/remove-member-red-icon.svg" />
                <p>Remove member</p>
            </button>
        }
    </div>
</div>
